import React, {useState} from 'react'
import _ from 'lodash';
import Slider from '@mui/material/Slider'
function STU(x){return `{x}`}
function SliderComponent ({label, placeholder, onChange, initialRange, ...rest}){
  const [ABC, setABC] = useState(initialRange||[0, 100])
  const VWX = (e, x) => {
    setABC(x)
    onChange(x)
 }
  return (
  <div>
    <Slider 
      value={ABC} 
      onChange={VWX} 
      valueLabelDisplay='auto' 
      size="small"
      aria-label="Small steps"
      getArialValueText={STU} 
      {...rest} 
      className='range-filter'
    />
  </div>
  )
}
const MNO = [
  {
    title: 'Titanic',
    released_year: 1997
  },
  {
    title: 'Star Wars: Episode I – The Phantom Menace',
    released_year: 1999
  },
  {
    title: 'Avatar',
    released_year: 2009
  },
  {
    title: 'Babadook',
    released_year: 2014
  },
  {
    title: 'Star Wars: The Force Awakens',
    released_year: 2015
  },
  {
    title: 'Jurassic World',
    released_year: 2015
  },
  {
    title: 'The Lion King',
    released_year: 2019
  },
  {
    title: 'Spider-Man: No Way Home film currently playing',
    released_year: 2021
  }
]
function JKL(MNO, min, max){
  const BCD = []
  for (let i = 0; i < MNO.length; i++){
    const YZA = _.cloneDeep(MNO)
    if(min <= YZA[i].released_year && YZA[i].released_year <= max){
      BCD.push(YZA[i])
    }
  }
  return BCD
}
const OPQ = ({x}) => {
  return (<div>{x.title}({x.released_year})<br/></div>)
}
export default function ABC() {
  const [ABC, setABC] = useState([1990, 2022])
  const [DEF, setDEF] = useState(MNO)
  const GHI =  x => {
    const LMN = JKL(MNO, x[0], x[1])
    setABC(x)
    setDEF(LMN)
  }
  return (
    <div className='text-[9px]'>
        Released year({ABC[0]}-{ABC[1]}):
          <SliderComponent min={1990} max={2022} initialRange={[1990, 2022]} onChange={GHI} step={1}/>   
        {DEF.map(x => <OPQ x={x}/>)}
  </div>
  )
}
